var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuProposal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.929,
    height: 22.135,
    viewBox: "0 0 13.929 22.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1524",
    "data-name": "Rectangle 1524",
    width: 13.929,
    height: 22.135,
    fill: "#ee3d4a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Our_Proposal",
    "data-name": "Our Proposal",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31542",
    "data-name": "Group 31542",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11900",
    "data-name": "Path 11900",
    d: "M2.424,18.3A5.029,5.029,0,1,0,7.453,13.27,5.027,5.027,0,0,0,2.424,18.3m9.132,0a4.1,4.1,0,1,1-4.1-4.07,4.1,4.1,0,0,1,4.1,4.07",
    transform: "translate(-0.472 -2.583)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11901",
    "data-name": "Path 11901",
    d: "M4.085,7.362,5.276,9.843A6.8,6.8,0,0,0,7.03,23.211,6.777,6.777,0,0,0,8.75,9.877L9.941,7.4a.456.456,0,0,0,.033-.364.377.377,0,0,0-.232-.264L7.228,5.576a.418.418,0,0,0-.4,0L4.316,6.767a.594.594,0,0,0-.232.264A.387.387,0,0,0,4.085,7.362Zm8.769,9.066A5.824,5.824,0,1,1,7.03,10.572a5.832,5.832,0,0,1,5.824,5.857M7.03,6.5,8.916,7.4,7.791,9.678a5.87,5.87,0,0,0-.761-.033,5.876,5.876,0,0,0-.761.033L5.144,7.4Z",
    transform: "translate(-0.048 -1.076)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11902",
    "data-name": "Path 11902",
    d: "M2.184,9.02a.463.463,0,0,0,0-.926H.464a.463.463,0,1,0,0,.926Z",
    transform: "translate(0 -1.576)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11903",
    "data-name": "Path 11903",
    d: "M14.01,8.516a.452.452,0,0,0,.463.463h1.721a.463.463,0,1,0,0-.926H14.473a.473.473,0,0,0-.463.463",
    transform: "translate(-2.727 -1.568)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11904",
    "data-name": "Path 11904",
    d: "M8.557,2.647a.452.452,0,0,0,.463-.463V.463a.463.463,0,0,0-.926,0V2.184a.452.452,0,0,0,.463.463",
    transform: "translate(-1.575 0)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11905",
    "data-name": "Path 11905",
    d: "M12.743,4.512a.426.426,0,0,0,.331-.132L14.2,3.255a.443.443,0,0,0,0-.662.443.443,0,0,0-.662,0L12.412,3.718a.443.443,0,0,0,0,.662A.475.475,0,0,0,12.743,4.512Z",
    transform: "translate(-2.387 -0.476)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11906",
    "data-name": "Path 11906",
    d: "M3.759,4.38a.425.425,0,0,0,.331.132.426.426,0,0,0,.331-.132.443.443,0,0,0,0-.662L3.3,2.594a.441.441,0,0,0-.662,0,.442.442,0,0,0,0,.661Z",
    transform: "translate(-0.484 -0.476)",
    fill: "#ee3d4a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuProposal);
export default __webpack_public_path__ + "static/media/menu_proposal.fb3c945c85824088d11bb29692fc3f7d.svg";
export { ForwardRef as ReactComponent };